<main
	#mainElement
	class="component-field-select-tree show"
	[class.st-touched]="valueInput"
	[class.st-error]="hasError"
	(mouseenter)="mouseenter()"
	(mouseleave)="mouseleave()"
>
	<section class="st-section-body" (mouseenter)="getFocus()" id="{{ fieldItem.entityKey }}-top">
		<div class="st-icon">
			@if (isRequired) {
				<lbca-icon
					[class.st-filled]="valueInput"
					name="lucide:asterisk"
					class="st-light"
					size="small"
				></lbca-icon>
			}
			<p class="st-label">{{ labelValue }}</p>
			<div class="icon-box st-icon-validation ml-[32px]"></div>
		</div>
		<div class="relative">
			<div #backContainerRef class="st-checked-itens">
				<div
					class="st-container-item"
					[class.disabled]="isDisabled"
					[class.opacity-0]="checkedItens.length === 0"
					(click)="!executing && !isDisabled ? backItem(backContainerRef) : null"
				>
					<lbca-icon name="lucide:move-left" class="st-arrow-back"></lbca-icon>
				</div>
				@for (item of checkedItens; track item; let i = $index) {
					<div
						#badgeRef
						class="st-badge theme-light-white"
						[class.theme-light]="true"
						[class.theme-dark]="false"
						[class.disabled]="isDisabled"
						[style.z-index]="i"
						(click)="!executing && !isDisabled ? removeOption(item, badgeRef, i) : null"
						[class.opacity-0]="item.hide"
						[class.removeItem]="item.remove"
						[style.top.px]="item.remove ? setTopRemove : badgeRef.offsetTop"
						[style.left.px]="item.remove ? setLeftRemove : badgeRef.offsetLeft"
					>
						<span class="st-text" [class.checked]="item.checkedItem">{{ item.label }}</span>
					</div>
					@if (item.checkedItem && !setTopRemove && !setLeftRemove) {
						<div class="st-container-item">
							<lbca-icon name="lucide:check" class="st-checked-ico active"></lbca-icon>
						</div>
					}
				}
				<div class="st-container-item" #refAppend>
					<span class="st-text"></span>
				</div>
			</div>
			@if (!isDisabled && ((hasChild && valueInput) || !valueInput)) {
				<div class="mt-[34px]">
					<lbca-search-box
						[placeholder]="'Pesquisar'"
						[queryOptions]="[]"
						[tagList]="tagList"
						(clear)="clearSearchValue()"
						(clearSearchFunction)="clearSearchFunction($event)"
						(searchValue)="setSearchValue($event)"
					></lbca-search-box>
				</div>
			}
			@if (!loading) {
				@if (options && options.length > 0) {
					<div class="st-shadow-cut mt-[34px]" [class.mt-[34px]]="checkedItens.length > 0">
						<span class="st-helper">{{ helperTextValue }}</span>
						@for (option of options; track option; let i = $index) {
							@if (option.id === unselectItem) {
								<span #refDispend></span>
							}
							<label
								#checkitem
								class="trs-eio"
								[class.st-template]="selectItem !== option.id"
								[class.st-badge]="selectItem === option.id"
								[class.motion-item]="selectItem === option.id || unselectItem === option.id"
								[class.motionNewItens]="motionFillStatus === 'newItens'"
								[class.motionReturnOldItens]="motionFillStatus === 'removed'"
								[class.motionItemChoosed]="motionFillStatus === 'choosed'"
								[class.disabled]="isDisabled"
								(click)="
									!executing && !isDisabled ? selectOption(option, checkitem, refAppend) : null
								"
								[style.top.px]="setTopTable"
								[style.left.px]="setLeftTable"
								[style.transition-duration.ms]="setTransitionMs"
								[style.animation-delay.ms]="i * 60"
							>
								<span class="st-text">{{ option.label }}</span>
								@if (option.hasChild) {
									<lbca-icon name="lucide:chevron-right" class="st-more"></lbca-icon>
								}
							</label>
						}
					</div>
				}
				@if ((!options || options.length === 0) && !loading && searched) {
					<div class="min-h-[180px] mt-[20px] mb-[20px]">
						<lbca-body-feedback place="module" feedbackIcon="notfound" type="row">
							<ng-container rowMessagePrimary>{{ fieldsLabels['table-not-found'] }}</ng-container>
							<ng-container rowMessageSecondary>
								{{ fieldsLabels['table-try-new-search'] }}
							</ng-container>
						</lbca-body-feedback>
					</div>
				}
			}
			<div class="justify-center flex">
				@if (showPagination) {
					<lbca-pagination
						[actualPage]="actualPage"
						(selectedPage)="selectedPage($event)"
						(orientation)="orientation($event)"
						[maxPages]="maxPages"
						[anchorLink]="fieldItem.entityKey + '-top'"
					></lbca-pagination>
				}
			</div>
			@if (loading) {
				<div class="h-[232px] w-full relative">
					<lbca-loading [position]="'relative'" class="loadPage"></lbca-loading>
				</div>
			}
		</div>
	</section>
</main>
